import { carregarEmpregadoresDaStore } from '@/integracoes/src-next/catalogos/catalogo-empregador.vuex'
import { freezeItems } from './freezeItems'

const CAMPOS_CANONICOS_EMPREGADOR = ['id', 'name', 'code', 'trading_name', 'tradingName', 'cnpj', 'cpf', 'cno_caepf', 'ceiCnoCaepf', 'id_repp', 'visivel', 'total_of_employees', 'totalOfEmployees', 'jurisdicao', 'numero_identificador', 'numeroIdentificador', 'numero_identificador_tipo', 'numeroIdentificadorTipo', 'comp_man']

export default {
  namespaced: true,
  state: {
    items: [],
    loading: false,
    pronto: false,
    atualizando: false,
    erro: null,
    sincronizadoEm: null
  },
  getters: {
    onlyIdRepp (state) {
      return state.items.filter(empregador => empregador.id_repp !== '')
    },
    todosEmpregadores (state) {
      return state.items
    },
    apenasVisiveis (state) {
      const empregadoresVisiveis = state.items.filter(empregador => empregador.visivel)
      return empregadoresVisiveis
    },
    visiveisComIdRepp (state) {
      const empregadoresVisiveis = state.items.filter(empregador => empregador.visivel)
      const empregadoresVisiveisComIdRepp = empregadoresVisiveis.filter(empregador => empregador.id_repp !== '')
      return empregadoresVisiveisComIdRepp
    },
    empregadoresJurisdicaoBrasil (state) {
      return state.items.filter(empregador => empregador.visivel && empregador.jurisdicao === 'BR')
    },
    empregadoresJurisdicaoArgentina (state) {
      return state.items.filter(empregador => empregador.visivel && empregador.jurisdicao === 'AR')
    },
    empregadoresJurisdicaoInternacional (state) {
      return state.items.filter(empregador => empregador.visivel && empregador.jurisdicao === 'XX')
    }
  },
  mutations: {
    saveItems (state, payload) {
      state.items = freezeItems(payload)
      state.loading = false
    },
    resetItems (state) {
      state.items = []
      state.pronto = false
      state.loading = false
      state.atualizando = false
      state.erro = null
      state.sincronizadoEm = null
    },
    publicarCatalogo (state, { items, ...estado }) {
      if (items !== undefined) state.items = freezeItems(items)
      Object.assign(state, estado)
    },
    loading (state, payload) {
      state.loading = Boolean(payload)
    }
  },
  actions: {
    async fetchItems ({ dispatch }, payload = {}) {
      const { additionalFields = [], fullReload = false } = payload || {}
      if (additionalFields.some(campo => !CAMPOS_CANONICOS_EMPREGADOR.includes(campo))) {
        return dispatch('consultarItensEspecificos', payload)
      }
      await carregarEmpregadoresDaStore(this, fullReload === true)
    },
    async consultarItensEspecificos (contexto, { additionalFields = [] } = {}) {
      const { API } = await import('src/services')
      const result = await API.employer.get({
        fields: JSON.stringify(['id', 'name', 'code', 'trading_name', 'cnpj', 'cpf', 'cno_caepf', 'id_repp', 'visivel', 'total_of_employees', ...additionalFields])
      })
      return result.body.success || []
    }
  }
}
